import { useQuery } from '@tanstack/react-query';
import { useAuthStore } from '../../auth/stores/authStore';
import { getPotStatusSummary } from '../api/dashboardApi';
import { dashboardKeys } from './dashboardKeys';

export function useGetPotStatusSummary() {
  const isAuthenticated = useAuthStore(state => state.isAuthenticated);

  return useQuery({
    queryKey: dashboardKeys.potStatusSummary(),
    queryFn: () => getPotStatusSummary(),
    enabled: isAuthenticated,
    staleTime: 30_000,
  });
}
